import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {mapValues} from 'lodash';
import {Currency} from '../../../../../shared/api/entity/currency';
import {CustomerAccount} from '../../../../../shared/api/entity/index';
import {NavigationService} from '../../../../../shared/navigation/index';
import {ProfileAccountsFilteringModel} from '../../api/entity/accounts-filter-model';
import {ProfileState} from '../../api/entity/index';
import {CustomerAccountsService, CustomerProfileService} from '../../api/service/index';
import {isNullOrUndefined} from 'util';
import {InjectOptionDialog, OptionDialog} from '../../../../../shared/option-dialog';
import {TranslateManager} from '../../../../../../../common/translate';

const STATE_ACTIVE_KEY = 'CUSTOMER.DETAILS.TAB.ACCOUNTS.STATE.ACTIVE';
const STATE_INACTIVE_KEY = 'CUSTOMER.DETAILS.TAB.ACCOUNTS.STATE.INACTIVE';

const STATE_INACTIVE_ID = 1;
const STATE_INACTIVE_VALUE = 'INACTIVE';

const STATE_ACTIVE_ID = 2;
const STATE_ACTIVE_VALUE = 'ACTIVE';

const PROFILE_STATE_BLOCKED = 'B';

const IBANS_SHOW_KEY = 'CUSTOMER_ACCOUNTS.SHOW_IBANS';
const IBANS_HIDE_KEY = 'CUSTOMER_ACCOUNTS.HIDE_IBANS';

const STATE_LOG_SHOW_KEY = 'CUSTOMER_ACCOUNTS.SHOW_STATE_LOG';
const STATE_LOG_HIDE_KEY = 'CUSTOMER_ACCOUNTS.HIDE_STATE_LOG';

@Component({
    selector: 'tfl-profile-detail-accounts',
    template: require('./profile.accounts.template.html'),
    providers: [CustomerAccountsService]
})
export class ProfileAccountsComponent implements OnInit {

    customerAccounts: CustomerAccount[];
    accountStates: [ProfileState];
    currencies: Currency [];
    filterModel: ProfileAccountsFilteringModel;
    DEFAULT_OPTION = 'undefined';
    isBlocked = false;

    private _profileId: number;

    @InjectOptionDialog('deactivate-reason-dialog') dialog: OptionDialog;

    constructor(private _navigation: NavigationService,
                private _customerAccountsService: CustomerAccountsService,
                private _customerProfileService: CustomerProfileService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private translateManager: TranslateManager) {
        this.resetFilterModel()
    }

    ngOnInit(): void {
        this.activatedRoute.parent.params.subscribe(params => {
            this._profileId = +params['id'];
            this.searchAccounts();
            this.checkCustomerProfileState();
        });
        this.fetchAccountStates();
        this.fetchCurrencies();
    }

    onChangeFilter(obj: object): void {
        this.searchAccounts();
    }

    searchAccounts() {
        this.preventOfDefaultSelectTagOptionOrValues();
        this._customerAccountsService.searchAccounts(this.filterModel, this._profileId)
            .subscribe(response => (this.customerAccounts = response));
    }

    newAccount(): void {
        if (this.router.url.indexOf('pending') > -1) {
            this._navigation.customers.profiles.pending.newAccount(this._profileId);
        } else {
            localStorage.setItem('profileId', this._profileId + '');
            this._navigation.customers.profiles.registered.newAccount(this._profileId);
        }
    }

    private checkCustomerProfileState() {
        this._customerProfileService.getCustomerProfile(this._profileId)
            .subscribe(customerProfile => {
                this.isBlocked = isNullOrUndefined(customerProfile) ? false : customerProfile.state === PROFILE_STATE_BLOCKED
            });
    }

    public getAccountStateText(state: string): string {
        if (state === STATE_ACTIVE_VALUE) {
            return STATE_ACTIVE_KEY;
        } else {
            return STATE_INACTIVE_KEY;
        }
    }

    public getNextAccountStateText(state: string): string {
        if (state === STATE_ACTIVE_VALUE) {
            return STATE_INACTIVE_KEY;
        } else {
            return STATE_ACTIVE_KEY;
        }
    }

    public changeState(account: CustomerAccount) {
        let targetAccountState = this.getStateIdFromName(account.state) === STATE_INACTIVE_ID ? STATE_ACTIVE_ID : STATE_INACTIVE_ID;
        let changeStateAction = (reason?: string) => {
            return this._customerAccountsService.changeAccountState(account.id, targetAccountState, reason)
                .subscribe(() => this.searchAccounts());
        };

        if (targetAccountState === STATE_INACTIVE_ID) {
            let options = {
                title: 'CUSTOMER_ACCOUNTS.DEACTIVATE.DIALOG.TITLE',
                confirmButtonText: 'CUSTOMER_ACCOUNTS.DEACTIVATE.DIALOG.BUTTONS.CONFIRM',
                cancelButtonText: 'CUSTOMER_ACCOUNTS.DEACTIVATE.DIALOG.BUTTONS.CANCEL',
                confirmButtonClass: 'btn-danger'
            };
            this.dialog
                .showInputDialog(options, {minlength: 1, maxlength: 150})
                .onConfirmAction((reason: string) => changeStateAction(reason));
        } else {
            changeStateAction();
        }
    }

    private getStateIdFromName(state: string): number {
        if (state === STATE_ACTIVE_VALUE) {
            return STATE_ACTIVE_ID;
        } else {
            return STATE_INACTIVE_ID;
        }
    }

    private fetchAccountStates() {
        this._customerAccountsService.getProfileStatesForRegisteredClients()
            .subscribe(states => (this.accountStates = states));
    }

    private fetchCurrencies() {
        this._customerAccountsService.getCurrencies()
            .subscribe(currencies => (this.currencies = currencies))
    }

    private preventOfDefaultSelectTagOptionOrValues() {
        this.filterModel = Object.assign(this.filterModel,
            mapValues(this.filterModel, (v) => (String(v) == this.DEFAULT_OPTION || String(v) == '') ? undefined : v));
    }

    private resetFilterModel() {
        this.filterModel = Object.assign(this.filterModel || {}, {
            accountName: undefined,
            accountNumber: undefined,
            accountCurrencyId: undefined,
            accountStateId: undefined
        });
    }

    private getActionIbansText(showLinks: boolean) {
        if (showLinks) {
            return IBANS_HIDE_KEY;
        } else {
            return IBANS_SHOW_KEY;
        }
    }

    private getActionStateLogText(showStateLog: boolean) {
        if (showStateLog) {
            return STATE_LOG_HIDE_KEY;
        } else {
            return STATE_LOG_SHOW_KEY;
        }
    }

    private currentAccountStateClass(accountState: string): string {
        return accountState === STATE_INACTIVE_VALUE ? 'customer-inactive' : 'customer-active';
    }

    private nextAccountStateClass(accountState: string): string {
        return accountState === STATE_INACTIVE_VALUE ? 'customer-active' : 'customer-inactive';
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/accounts/profile.accounts.component.ts